import { axiosInstance as request } from '@/api/rest.service'

function getFilters(filters) {
  return filters.reduce((acc, curr) => {
    acc[`filter[${curr}]`] = true
    return acc
  }, {})
}

/* General */
export const updateLayout = (layoutId, payload) => {
  return request.put(`layouts/sub-contexts/${layoutId}/definition`, payload)
}
/* General */

/* Subscription Show */
export const updateSubscriptionPeriod = (id, payload) => {
  return request.patch(`subscription-periods/${id}`, payload)
}

export const getSubscriptionPeriodsWithTaskApplicability = subId => {
  return request.get(`subscriptions/${subId}/subscription-periods?append=task_applicability`)
}

export const updateStakeDepField = (periodId, depId, payload) => {
  return request.put(`subscription-periods/${periodId}/departments/${depId}`, payload)
}

export const getTaskApplicabilityForSub = subId => {
  return request.get(`subscription-periods/create/subscription/${subId}`)
}

export const getStakesForPeriod = periodId => {
  return request.get(`subscription-periods/${periodId}/departments-stakeholders`)
}

export const addStakeholderForPeriod = (periodId, payload) => {
  return request.post(`/subscription-periods/${periodId}/stakeholders`, payload)
}

export const addDepartmentForPeriod = (periodId, payload) => {
  return request.post(`/subscription-periods/${periodId}/departments`, payload)
}

export const updateStakeholder = (sHolderId, payload) => {
  return request.put(`stakeholders/${sHolderId}`, payload)
}

export const deleteStakeholderFromDep = (periodId, stakeId, payload) => {
  return request.delete(`subscription-periods/${periodId}/stakeholders/${stakeId}`, { data: payload })
}

export const deleteDepFromStakes = (periodId, depId) => {
  return request.delete(`subscription-periods/${periodId}/departments/${depId}`)
}

export const getSubscriptionClaims = id => {
  return request.get(`/emailing/preview/subscription-claims/${id}`)
}

export const sendEmail = payload => {
  return request.post('/emailing/send', payload)
}

/* Subscription show */

export const sendSubscriptionNote = (subId, payload) => {
  return request.post(`/subscriptions/${subId}/notes`, payload)
}

export const updateSubscriptionNote = (subId, noteId, payload) => {
  return request.put(`/subscriptions/${subId}/notes/${noteId}`, payload)
}

export const deleteSubscriptionNote = (subId, noteId) => {
  return request.delete(`/subscriptions/${subId}/notes/${noteId}`)
}

/* Departments */

export const departmentsApi = (method, payload, id = '', withFilter = '') => {
  return request[method](`/departments${id ? '/' + id : ''}${withFilter}`, payload)
}

export const getStakesDepartments = () => {
  return request.get('/stakeholders?include=departments')
}

/* Departments */

/* Subscription workflow management */

export const getFilteresSubscriptions = filter => {
  return request.get(`/subscription-periods/task-applicability?filter[${filter}]=true`)
}

export const saveSubscriptionWorkflow = payload => {
  return request.patch('/subscription-periods/task-applicability', payload)
}

export const newSubsSettingsApi = (method, payload) => {
  return request[method]('/subscription-periods/task-applicability/general', payload)
}

/* Subscription workflow management */

/* User Settings */

export const getUsers = () => {
  return request.get('/users')
}

export const getCreateUserData = () => {
  return request.get('/users/create')
}

export const createUser = payload => {
  return request.post('/users', payload)
}

export const updateUser = (payload, id) => {
  return request.put(`/users/${id}`, payload)
}

/* User Settings */

/* Index Pages */

export const getProducts = params => {
  return request.get(`/products?paginated=true`, { params })
}

export const getVendors = (params, pagination = true) => {
  return request.get(`/vendors${pagination ? '?paginated=true' : ''}`, {
    params
  })
}

export const getPublishers = (params, pagination = true) => {
  return request.get(`/publishers${pagination ? '?paginated=true' : ''}`, {
    params
  })
}

export const getLicenses = params => {
  return request.get('/licenses?paginated=true', { params })
}

export const getTitleList = id => {
  return request.get(`/title-lists/${id}`)
}

/* Index Pages */

/* Publisher Show */

export const getPublisher = id => {
  return request.get(`/publishers/${id}`)
}

export const getPublisherProducts = (id, params, filters) => {
  const paramsWithFilters = {
    ...getFilters(filters),
    ...params
  }
  return request.get(`/publishers/${id}/products?paginated=true`, {
    params: paramsWithFilters
  })
}

export const getPublisherLicenses = id => {
  return request.get(`/publishers/${id}/licenses?include=periods.owner`)
}

export const getPublisherContacts = id => {
  return request.get(`/publishers/${id}/contacts`)
}

/* Publisher Show */

/* Vendor Show */

export const getVendor = id => {
  return request.get(`/vendors/${id}`)
}

export const getVendorSubscriptions = (id, params) => {
  return request.get(`/vendors/${id}/subscriptions?paginated=true`, { params })
}

export const getVendorContacts = id => {
  return request.get(`/vendors/${id}/contacts`)
}

/* Vendor Show */

/* Title List Show */

export const updateTitleList = (id, params) => {
  return request.patch(`title-lists/${id}`, params)
}

export const getTitleListPublications = id => {
  return request.get(`/title-lists/${id}/publications`)
}

export const createTitleListPublication = (id, payload) => {
  return request.post(`/title-lists/${id}/publications`, payload)
}

export const deleteTitleListPublication = id => {
  return request.delete(`/publications/${id}`)
}

/* Title List Show */

/* Plan Workflow Task Modal */

export const getPlanWorkflowDataForDashboard = params => {
  return request.get('/progress-bar/tasks/data/plan-workflow?paginated=true', {
    params
  })
}

export const getPlanWorkflowDataForSubscriptionShow = (id, params) => {
  return request.get(`/progress-bar/tasks/data/plan-workflow/subscription-periods/${id}?paginated=true`, { params })
}

export const setPlanWorkflowSubscription = (id, action) => {
  return request.post(`/subscription-periods/${id}/workflow/${action}`)
}

export const setAllPlanWorkflowSubscriptions = action => {
  return request.post(`/subscription-periods/workflow/${action}`)
}

/* Plan Workflow Task Modal */

/* Excel Exports */

export const getExportLinkForView = (view, filters, params) => {
  const paramsWithFilters = {
    ...getFilters(filters),
    ...params
  }
  return request.get(`/exports/${view}`, {
    params: paramsWithFilters,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/* Excel Exports */

/* Reports Page */

export const getReportTypes = () => {
  return request.get('/reports/types')
}

export const getReportTypePreview = (reportTypeId, params) => {
  return request.get(`/reports/types/${reportTypeId}/preview?paginated=true`, {
    params
  })
}

export const generateReport = (reportTypeId, params) => {
  return request.get(`/reports/types/${reportTypeId}/generate`, { params })
}

export const generateSavedReport = id => {
  return request.get(`/reports/${id}/generate`)
}

export const getReports = () => {
  return request.get('/reports')
}

export const saveReport = payload => {
  return request.post('/reports', payload)
}

export const updateReport = (reportId, payload) => {
  return request.put(`/reports/${reportId}`, payload)
}

export const deleteReport = reportId => {
  return request.delete(`/reports/${reportId}`)
}

/* Reports Page */
